import * as actionTypes from './actionTypes';

export const createDraft = (reportYear, reportMode) => ({
  type: actionTypes.CREATE_DRAFT,
  payload: { reportMode, reportYear },
});
export const createDraftSuccess = (payload) => ({
  type: actionTypes.CREATE_DRAFT_SUCCESS,
  payload,
});
export const createDraftFailure = (payload) => ({
  type: actionTypes.CREATE_DRAFT_FAILURE,
  payload,
});

export const setDraft = (payload) => ({ type: actionTypes.SET_DRAFT, payload });

export const refineDraft = (declarationId, mode) => ({
  type: actionTypes.REFINE_DRAFT,
  payload: { declarationId, mode },
});
export const refineDraftSuccess = (payload) => ({
  type: actionTypes.REFINE_DRAFT_SUCCESS,
  payload,
});
export const refineDraftFailure = (payload) => ({
  type: actionTypes.REFINE_DRAFT_FAILURE,
  payload,
});

export const getDraft = (cardId) => ({ type: actionTypes.GET_DRAFT, payload: { cardId } });
export const getDraftSuccess = (payload) => ({ type: actionTypes.GET_DRAFT_SUCCESS, payload });
export const getDraftFailure = (error) => ({ type: actionTypes.GET_DRAFT_FAILURE, error });

export const updateDraft = (payload) => ({ type: actionTypes.UPDATE_DRAFT, payload });
export const updateDraftSuccess = (payload) => ({
  type: actionTypes.UPDATE_DRAFT_SUCCESS,
  payload,
});
export const updateDraftFailure = (error) => ({ type: actionTypes.UPDATE_DRAFT_ERROR, error });

export const updateXmlDraft = (payload) => ({ type: actionTypes.UPDATE_XML_DRAFT, payload });
export const updateXmlDraftSuccess = (payload) => ({
  type: actionTypes.UPDATE_XML_DRAFT_SUCCESS,
  payload,
});
export const updateXmlDraftFailure = (error) => ({
  type: actionTypes.UPDATE_XML_DRAFT_FAILURE,
  error,
});

export const resetState = () => ({ type: actionTypes.RESET_STATE });

export const initialize = (payload) => ({ type: actionTypes.INITIALIZE, payload });
export const initializeSuccess = (payload) => ({ type: actionTypes.INITIALIZE_SUCCESS, payload });
export const initializeFailure = (error) => ({
  type: actionTypes.INITIALIZE_FAILURE,
  payload: error,
});

// Initial Data actions
export const getInitialData = (payload) => ({ type: actionTypes.INITIAL_DATA, payload });
export const getInitialDataSuccess = (payload) => ({
  type: actionTypes.INITIALIZE_SUCCESS,
  payload,
});
export const getInitialDataFailure = (error) => ({ type: actionTypes.INITIAL_DATA_FAILURE, error });

export const getParentDeclarationByYear = (reportYear) => ({
  type: actionTypes.GET_PARENT_DECLARATION_BY_YEAR,
  payload: { reportYear },
});
export const getParentDeclarationByYearSuccess = (payload) => ({
  type: actionTypes.GET_PARENT_DECLARATION_BY_YEAR_SUCCESS,
  payload,
});
export const getParentDeclarationByYearFailure = (payload) => ({
  type: actionTypes.GET_PARENT_DECLARATION_BY_YEAR_ERROR,
  payload,
});

export const submitInitialData = (payload) => ({ type: actionTypes.SUBMIT_INITIAL_DATA, payload });
export const submitInitialDataSuccess = (payload) => ({
  type: actionTypes.SUBMIT_INITIAL_DATA_SUCCESS,
  payload,
});
export const submitInitialDataFailure = (error) => ({
  type: actionTypes.SUBMIT_INITIAL_DATA_FAILURE,
  error,
});

// Income Step actions
export const getIncomeData = (payload) => ({ type: actionTypes.INCOMES_DATA, payload });
export const getIncomeDataSuccess = (payload) => ({
  type: actionTypes.INCOMES_DATA_SUCCESS,
  payload,
});
export const getIncomeDataFailure = (error) => ({ type: actionTypes.INCOMES_DATA_FAILURE, error });

export const getNdfl2ByYear = (reportYear) => ({
  type: actionTypes.GET_NDFL2_BY_YEAR,
  payload: { reportYear },
});
export const getNdfl2ByYearSuccess = (payload) => ({
  type: actionTypes.GET_NDFL2_BY_YEAR_SUCCESS,
  payload,
});
export const getNdfl2ByYearFailure = (error) => ({
  type: actionTypes.GET_NDFL2_BY_YEAR_ERROR,
  error,
});

// Submit step actions
export const getSubmitData = (payload) => ({ type: actionTypes.SUBMIT_DATA, payload });
export const getSubmitDataSuccess = (payload) => ({
  type: actionTypes.SUBMIT_DATA_SUCCESS,
  payload,
});
export const getSubmitDataFailure = (error) => ({ type: actionTypes.SUBMIT_DATA_FAILURE, error });

export const submitDeclaration = (payload) => ({ type: actionTypes.SUBMIT_DECLARATION, payload });
export const setDeclarationSubmitted = (payload) => ({
  type: actionTypes.SET_DECLARATION_SUBMITTED,
  payload,
});

// Receipts actions
export const setReceiptsLink = (payload) => ({ type: actionTypes.SET_RECEIPTS_LINK, payload });
export const setReceiptsLinkSuccess = (payload) => ({
  type: actionTypes.SET_RECEIPTS_LINK_SUCCESS,
  payload,
});
export const setReceiptsLinkFailure = (error) => ({
  type: actionTypes.SET_RECEIPTS_LINK_FAILURE,
  error,
});

// Saved draft actions
export const getSavedDrafts = (payload) => ({ type: actionTypes.GET_SAVED_DRAFTS, payload });
export const getSavedDraftsSuccess = (payload) => ({
  type: actionTypes.GET_SAVED_DRAFTS_SUCCESS,
  payload,
});
export const getSavedDraftsFailure = (error) => ({
  type: actionTypes.GET_SAVED_DRAFTS_FAILURE,
  error,
});

export const resetSavedDraft = (payload) => ({ type: actionTypes.RESET_SAVED_DRAFT, payload });

export const updateCurrentDraft = (payload) => ({
  type: actionTypes.UPDATE_CURRENT_DRAFT,
  payload,
});

export const starStepFetching = (payload) => ({ type: actionTypes.START_STEP_FETCHING, payload });
export const stopStepFetching = (payload) => ({ type: actionTypes.STOP_STEP_FETCHING, payload });

export const saveDraftAndExit = (formName, location) => ({
  type: actionTypes.SAVE_DRAFT_AND_EXIT,
  payload: { formName, location },
});

// Overpayments init actions
export const initOverpayments = (payload) => ({ type: actionTypes.OVERPAYMENTS_DATA, payload });
export const initOverpaymentsSuccess = (payload) => ({
  type: actionTypes.OVERPAYMENTS_DATA_SUCCESS,
  payload,
});
export const initOverpaymentsFailure = (error) => ({
  type: actionTypes.OVERPAYMENTS_DATA_FAILURE,
  error,
});

// Overpayments submit actions
export const submitOverpayments = (payload) => ({
  type: actionTypes.OVERPAYMENTS_SUBMIT_DATA,
  payload,
});
export const submitOverpaymentsSuccess = (payload) => ({
  type: actionTypes.OVERPAYMENTS_SUBMIT_DATA_SUCCESS,
  payload,
});
export const submitOverpaymentsFailure = (error) => ({
  type: actionTypes.OVERPAYMENTS_SUBMIT_DATA_FAILURE,
  error,
});
